import React, { useEffect, useState } from "react";
import { Testimonials as TestimonialsApi } from "@/lib/api";
import EditableHTML from "./EditableHTML";
import { Quote, Star } from "lucide-react";

const TestimonialsSection = ({ content = {} }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        setItems(await TestimonialsApi.list(true));
      } catch {}
    })();
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="water-section py-28" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14">
          <div className="text-xs uppercase tracking-[0.22em] text-atc-green mb-5">
            <EditableHTML html={content.testimonials_eyebrow} as="span" />
          </div>
          <EditableHTML
            html={content.testimonials_title}
            className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight chrome-gradient-text"
          />
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {items.map((t, idx) => (
            <figure
              key={t.id}
              className="glass glass-hover rounded-2xl p-7 relative overflow-hidden"
              data-testid={`testimonial-${idx}`}
            >
              <Quote className="absolute -top-3 -right-2 h-24 w-24 text-white/[0.03]" />
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: t.rating || 5 }).map((_, i) => (
                  <Star key={i} className="h-3.5 w-3.5 text-atc-green fill-atc-green" style={{ fill: "#3FBF3F" }} />
                ))}
              </div>
              <blockquote className="text-slate-200 text-base leading-relaxed">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 border-t border-white/5 pt-4">
                <div className="font-display font-bold text-white text-sm">{t.author}</div>
                {t.role && <div className="text-xs text-slate-400 mt-1">{t.role}</div>}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
